require('./bootstrap');
require('jquery-validation');

let hd = $(".header");
let jno = $(".js-nav-offset");
let mTg = $('#menuToggle');

const initMenu = function() {
    const stickyMenu = () => {
        $(window).scroll(function () {
            var a = $(window).scrollTop(),
                b = hd.outerHeight();
            a > b + 40 ? (hd.addClass("fixed"),
                    jno.addClass("active")) :
                (hd.removeClass("fixed"),
                    jno.removeClass("active"))
    
            a > $(window).height() ? $(".buttonWhatsapp").show() : $(".buttonWhatsapp").hide()
        })
    }
    
    const toggle = () => {
        mTg.on('click', function () {
            resetMobileMenu()
            isChecked = $(this).is(':checked')
    
            if (isChecked) {
                $('.menuMob').addClass('active');
                $('.menu').addClass('active');
                $('body').addClass('o-false');
            } else {
                hideMenuMobile()
            }
        })
    }

    const btnTop = () => {
        $(".buttonBacktop").click(function () {
            $("html, body").animate({
                scrollTop: 0
            }, "slow")
        });
    };

    const dropMenu = () => {
        $(".dropItem__parent").on('click', function () {
            // if ($(this).hasClass('active')) {
            //     $(".dropItem__parent").removeClass('active');
            // } else {
            //     $(".dropItem__parent").removeClass('active');
            //     $(this).addClass('active');
            // }
            $(".dropItem__parent").removeClass('active');
            $(this).addClass('active');
        });
    }

    return {
        init: function() {
            stickyMenu();
			toggle();
            btnTop();
            dropMenu();
        }
    };
}();

var initDOm = function () {
    const buttonPassword = () => { 
        $("#btnpass").click(function () {
            let input = $($(this).attr("toggle"));
            if (input.attr("type") == "password") {
                input.attr("type", "text");
                $(this).addClass("show")
            } else {
                $(this).removeClass("show")
                input.attr("type", "password");
            }
        });
    }

    const customSelect = () => {
        $('select').each(function () {
            window.loadCustomSelect(this.id);
        });
    };

    return {
        init: function() {
            buttonPassword();
            customSelect();
        }
    };
}();

jQuery( document ).ready(function( $ ) {
    $(window).on('popstate', function() {
       location.reload(true);
    });
 });

// if (window.history && window.history.pushState) {
//     window.history.pushState('forward', null, '');
//     $(window).on('popstate', function () {
//         window.uncheckedMenu();
//         window.hideMenuMobile();
//     });
// }

$(window).on('resize', function () {
    window.uncheckedMenu();
    window.hideMenuMobile();
    window.updateMenu();
});

window.setShareLinks = () => {
    var pageUrl = encodeURIComponent(document.URL);
    var title = encodeURIComponent(document.title);

    $(".fbshare.shareLink").on("click", function() {
        url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
        socialWindow(url);
    });

    $(".twshare.shareLink").on("click", function() {
        url = "https://twitter.com/intent/tweet?url=" + pageUrl + "&text=" + title;
        socialWindow(url);
    });

    $(".washare.shareLink").on("click", function() {
        url = "https://api.whatsapp.com/send?text=" + title + ' ' + pageUrl;
        socialWindow(url, '_blank');
    });

    $(".mailshare.shareLink").on("click", function() {
        url = "mailto:?Subject=" + title + "&amp;Body=" + pageUrl;
        socialWindow(url);
    });
}

window.socialWindow = (url, target = null) => {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    if(target) {
        window.open(url, target);
    }

    window.open(url, "NewWindow", params);
}

window.viewport = () => {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return {
        width: e[a + 'Width'],
        height: e[a + 'Height']
    };
}

window.updateMenu = () => {
    $(".dropItem__parent>.dropLink").find("span").remove();
    resetMobileMenu()

    if ($('#menu').css('display') == 'none') {
        //console.log("desktop")        
        $('.menuMob').removeClass('mobile');
        hd.removeClass('mobile');
        /* move nav position in desktop */
        $('.nav').appendTo('.headerWrap');
        $('.drop').appendTo('#dropDesk');
        $('#search').attr('placeholder', 'Search');
    } else {
        //console.log("mobile")
        $('.menuMob').addClass('mobile');
        hd.addClass('mobile');
        /* move nav position in mobile */
        $('.nav').appendTo('#navMob');
        $('.drop').appendTo('#dropMob');
        $(".dropItem__parent>.dropLink").append("<span class='icon-chevron'></span>");
        $('#search').attr('placeholder', 'Search');
    }
    $('.headerWrap').removeClass('hidden');
}

window.resetMobileMenu = () => {
    $('.menuTab__btn').removeClass('active');
    $('#utamabtn').addClass('active');
    $('.menuTab__content').removeClass('active').css("display", "none");
    $('#utama').addClass('active').css("display", "block");
}

window.uncheckedMenu = () => {
    mTg.prop('checked', false);
}

window.hideMenuMobile = () => {
    $('.menuMob').removeClass('active');
    $('.menu').removeClass('active');
    $('.menu').removeClass('active');
    $('body').removeClass('o-false');
}

let drop = $('.drop');

window.openCategory = (e) => {
    jQuery(e).toggleClass('active');
    drop.toggleClass('visible');
}

document.getElementsByTagName("body")[0].addEventListener("click", function (event) {
    //hide category menu
    $('.buttonCateg').removeClass('active');
    drop.removeClass('visible');
}, false);

drop.on('click', function (e) {
    e.stopPropagation();
})

window.openUserMenu = (e) => {
    let drop = $('.userDrop');
    jQuery(e).toggleClass('active');
    drop.toggleClass('visible');
}

window.openTabMenu = (evt, cityName) => {
    var i, tablinkcontent, tabbutton;
    tablinkcontent = document.getElementsByClassName("menuTab__content");
    for (i = 0; i < tablinkcontent.length; i++) {
        tablinkcontent[i].style.display = "none";
    }
    tabbutton = document.getElementsByClassName("menuTab__btn");
    for (i = 0; i < tabbutton.length; i++) {
        tabbutton[i].className = tabbutton[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
}

$(document).on('click', '#pagination a', function(event) {
    event.preventDefault();

    let url = $(this).attr('href');
    window.history.pushState({}, null, url);
    
    $.ajax({
        type: 'GET',
        url: url,
        success:function(data) {
            $('#list-ajax').html(data);
            $('html, body').animate({
                scrollTop: $("#list-ajax").parent().parent().offset().top
            }, 1000);
        }
    });
    return false;
})

$(document).on('change', '#sort', function() {
    let order = $(this).val(),
        url = window.location.href.split('?')[0];
        url += '?page=1';

    $.ajax({
        url: url,
        dataType: 'html',
        type: "GET",
        data: {
            order: order,
        },
    })
    .done(function(response) {
        $('#list-ajax').html(response);
        $('html, body').animate({
            scrollTop: $("#list-ajax").parent().parent().offset().top
        }, 1000);

        var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname +'?page=1';  
        window.history.pushState({ path: refresh }, '', refresh);
    })
    .fail(function(xhr, textStatus, errorThrown) {
        console.log(errorThrown);
    });
});


const subscribe = function () {
    $('#form-subscribe').validate({
        rules:{
            email:{
                required: true,
                email: true
            },
        },
        errorPlacement: function(error, element) {
            error.insertAfter(element);
        },
        errorElement: 'div',
        errorClass: 'formError__txt',
        submitHandler: function (form) {
            $.ajax({
                type: "POST",
                url: $(form).attr('action'),
                data: $(form).serialize(),
                success: function(data) { 
                    $('#form-subscribe')[0].reset();
                    $("#msg-subscribe").show().html('<span class="icon icon-check mr1"></span>' + data.message);
                    setTimeout(function() {
                        $("#msg-subscribe").html(null).hide();
                    }, 3000);
                },
                error: function (err) {
                    if (err.status == 422) {
                        $.each(err.responseJSON.errors, function (i, error) {
                            var el = $(document).find('[name="'+ i +'"]');
                            el.after($('<div class="formMsg formMsg__error display-flex mt1"><span class="icon icon-close mr1"></span>' + error[0] + '</div>'));
                        });

                        setTimeout(function() {
                            $(".formMsg__error").remove();
                        }, 3000);
                    }
                }
            });
            return false;
        }
    });
}

window.loadCustomSelect = (id) => {
    $('#' + id).each(function () {
        var $this = $(this),
            numberOfOptions = $(this).children('option').length,
            defaultSelected = $('#' + id).find(":selected").length;

        $this.addClass('hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="styledSelect"></div>');
        
        var $styledSelect = $this.next('div.styledSelect');
        if(defaultSelected > 0) {
            $styledSelect.text($('#' + id).find(":selected").text());
        } else {
            $styledSelect.text($this.children('option').eq(0).text());
        }
        
        var $list = $('<ul />', {
            'class': 'options hidden'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        var $listItems = $list.children('li');
        $styledSelect.click(function (e) {
            e.stopPropagation();
            let option = $(this).next('ul.options');
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active');
            });
            $(this).toggleClass("active");
            option.toggleClass("hidden");
            if (option.hasClass('hidden')) {
                $(this).removeClass("open");
            } else {
                $(this).addClass("open");
            }
        });

        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active open');
            $this.val($(this).attr('rel'));
            $list.addClass('hidden');
            $this.trigger('change');
            //console.log($this.val()); /*Uncomment this for demonstration! */
        });
        
        $(document).click(function () {
            $styledSelect.removeClass('active open');
            $list.addClass('hidden');
        });
    });
}

window.setWishlist = (elem, type, bookId, status) => {
    let parentElem = elem.closest('.list-wishlist').id;

    $.ajax({
        type: "POST",
        url: HOST_URL + '/book/wishlist/' + bookId,
        data: {
            type: type,
            status: status
        }
    })
    .done(function(response) {
        $('#' + parentElem).html(response);
    })
    .fail(function(xhr, textStatus, errorThrown) {
        if(403 == xhr.status) {
            window.location.href = HOST_URL + '/email/verify';
        }
    });
}


jQuery(function() {
    initMenu.init();
    initDOm.init();
    subscribe();
    
    window.uncheckedMenu();
    window.hideMenuMobile();
    window.updateMenu();
});